import { jsPDF } from "jspdf";

export function imageToPdf(blob) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const imageUrl = URL.createObjectURL(blob);

    img.onload = () => {
      // Create PDF with same size as image
      const pdf = new jsPDF({
        orientation: img.width > img.height ? "landscape" : "portrait",
        unit: "px",
        format: [img.width, img.height],
      });

      const imageType = blob.type === "image/png" ? "PNG" : "JPEG";

      pdf.addImage(
        img,
        imageType,
        0,
        0,
        img.width,
        img.height
      );

      const pdfBlob = pdf.output("blob");

      URL.revokeObjectURL(imageUrl);

      resolve(URL.createObjectURL(pdfBlob));
    };

    img.onerror = reject;
    img.src = imageUrl;
  });
}